<template>
  <button
    @click="startRecordingCLick"
    title="Start recording"
    v-tippy><font-awesome-icon :icon="faDotCircle" /></button>
</template>

<script>
  import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
  import { faDotCircle } from '@fortawesome/pro-light-svg-icons/faDotCircle'
  import { createNamespacedHelpers } from 'vuex'

  const { mapActions, mapState } = createNamespacedHelpers('conference')

  export default {
    components: {
      FontAwesomeIcon
    },
    data () {
      return {
        faDotCircle,
        swalStartErrorData: {
          type: 'error',
          text: 'Sorry, recording could not be started. Please try again.',
          confirmButtonText: 'OK',
          showCloseButton: true,
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false
        }
      }
    },
    computed: mapState([
      'activity',
      'recordingButtonDisabled'
    ]),
    methods: {
      ...mapActions([
        'startRecording',
        'resumeRecording',
        'markRecordingState',
        'markRecordingButtonDisabled'
      ]),
      startRecordingCLick () {
        this.markRecordingButtonDisabled(true)
        this.startRecording(this.swalStartErrorData)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// recording-start-button.vue?ef98fca2